import _DTO from "./_DTO";
import SoftwareLicenceDTO from "./SoftwareLicenceDTO";

export default class SoftwareLicenseSelectionDTO extends _DTO {

  constructor(selection) {
    super();
    this.softwareSelection = selection.softwareSelection;
    this.softwareLicences = SoftwareLicenseSelectionDTO.getMappedOrDefault(selection, 'softwareLicences', [], data => data.map(s => new SoftwareLicenceDTO(s)));
    this.licenseModel = selection.licenseModel;
    this.servicePlanActivated = selection.servicePlanActivated;
  }
}
